import {
  useGetApiAdministrationActionmodulesTemplatesActionModuleId,
  useGetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId
} from '@/api/generated/administrator-user/administrator-user'
import {
  useGetApiCompaniesCurrentActionmodulesActionModuleId,
  useGetApiCompaniesCurrentActionmodulesTemplatesActionModuleId,
} from '@/api/generated/company-management-user/company-management-user'
import {ActionModuleKind, type ActionModuleResponse} from '@/api/model'

interface Args {
  isAdmin: boolean
  /** Required in admin scope; absent in CMU scope. */
  companyId?: number
  actionModuleId?: number
  kind?: ActionModuleKind
}

// Loads a single action module for the editor, branching on scope:
// - Admin: `administration/companies/{companyId}/actionmodules/{id}`.
// - CMU:   `companies/current/actionmodules/{id}`.
// Both generated hooks are called (rules of hooks); `enabled` gates the one that fires.
// Unwraps the axios response (`data.data`) per the portal's response-shape convention.
export function useActionModule({ isAdmin, companyId, actionModuleId, kind = ActionModuleKind.Live }: Args) {
  const adminQuery =
    kind === ActionModuleKind.Live
      ? useGetApiAdministrationCompaniesCompanyIdActionmodulesActionModuleId(companyId ?? 0, actionModuleId ?? 0, {},
        {query: {enabled: isAdmin && !!actionModuleId && companyId != null}})
      : useGetApiAdministrationActionmodulesTemplatesActionModuleId(actionModuleId ?? 0, {companyId: companyId},
        {query: {enabled: isAdmin && !!actionModuleId}})

  const cmuQuery =
    kind === ActionModuleKind.Live
      ? useGetApiCompaniesCurrentActionmodulesActionModuleId(actionModuleId ?? 0, {},
        {query: {enabled: !isAdmin && !!actionModuleId}})
      : useGetApiCompaniesCurrentActionmodulesTemplatesActionModuleId(actionModuleId ?? 0, {},
        {query: {enabled: !isAdmin && !!actionModuleId}})

  const query = isAdmin ? adminQuery : cmuQuery
  const actionModule = ((query.data as { data?: ActionModuleResponse })?.data ??
    (query.data as ActionModuleResponse | undefined)) as ActionModuleResponse | undefined

  return { isLoading: query.isLoading, isError: query.isError, actionModule }
}
